import React from 'react'
import { Query } from 'react-apollo'
import { gql } from 'apollo-boost'

import Base from './Select'

const GET_STATES = gql`
  {
    stateOrProvinces {
      id
      name
    }
  }
`

const Select = ({placeholder, ...others}) =>
  <Query query={GET_STATES}>
    {({data}) =>
      <Base
        placeholder={placeholder || 'Select a state...'}
        options={!data || !data.stateOrProvinces
          ? []
          : data.stateOrProvinces.map(s => ({key: s.id, label: s.name, value: s.id}))
        }
        {...others}
      />
    }
  </Query>

export default Select


// WEBPACK FOOTER //
// ./src/components/StateSelect.js